import { ISearchType, ISearchTypeAction, SearchType } from '../../../models/filters/type';
import { DEFAULT_FILTERS } from './default_filters';

export const SEARCH_TYPE_UPDATE = 'search/SEARCH_TYPE_UPDATE';

const initialState: ISearchType = {
  searchType: 'buy',
  isDirty: false,
};

const defaultAction: ISearchTypeAction = {
  type: '',
  payload: {},
};

export const typeReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case SEARCH_TYPE_UPDATE:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
};

export const setSearchType = (searchType: SearchType): ISearchTypeAction => {
  return {
    type: SEARCH_TYPE_UPDATE,
    payload: {
      searchType,
    },
  };
};

export const setDirty = (isDirty: boolean): ISearchTypeAction => {
  return {
    type: SEARCH_TYPE_UPDATE,
    payload: {
      isDirty,
    },
  };
};

export const setTypeSection = (section: string): ISearchTypeAction => {
  return {
    type: SEARCH_TYPE_UPDATE,
    payload: {
      section,
      searchType: DEFAULT_FILTERS[section].type_value,
    },
  };
};
